import { render, staticRenderFns } from "./HkiaraceCardDisplayFrameForceMobile.vue?vue&type=template&id=5dca51be"
import script from "./HkiaraceCardDisplayFrameForceMobile.vue?vue&type=script&lang=js"
export * from "./HkiaraceCardDisplayFrameForceMobile.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceCardDisplayFrameForceMobile.vue?vue&type=style&index=0&id=5dca51be&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports